export enum Analytics {
  activity = 'activity',
  electricityUsage = 'electricityUsage',
  disasterInfoOnly = 'disasterInfoOnly',
  solar = 'solar'
}
export type Partner = {
  name: string
  postalCode?: string | null
  prefecture?: string | null
  address?: string | null
  phone?: string | null
  web?: string | null
  products: Product[]
  start?: string | null
  code?: string | null
  codePartner?: string | null
  type: string
  gmoCardSeq?: string | null
  copyProducts?: boolean | null
  useSchedules?: boolean | null
  useDisasterInfo?: boolean | null
  useCheckSchedules?: boolean | null
  disasterInfoMessage?: string | null
  checkSchedules?: CheckSchedules[] | null
  exports?: string[] | null
  useOwnSender?: boolean | null
  sender?: Sender | null
  useCopyContact?: boolean | null
  id: string
}
export type Product = {
  contactDepartment?: string | null
  contactEmail: string
  contactName?: string | null
  contactPhone?: string | null
  contactOrganization?: string | null
  places?: string[] | null
  name: string
  prices: Price[]
  analytics: Analytics
  criterionsAll?: boolean | null
  criterions: Criterion[]
  code?: string | null
  chargeStart?: number | null
  useBankAccount?: boolean | null
  bankAccountTargetDate?: string | null
  useCreditCard?: boolean | null
  notCopy?: boolean | null
}
export type Price = {
  price: number
  minAmount?: number | null
  maxAmount?: number | null
}
export type Criterion = {
  start?: string | null
  end?: string | null
  continuousLimit?: number | null
  startDate?: string | null
  endDate?: string | null
  enabled?: boolean | null
  threshold?: number | null
}
export type CheckSchedules = {
  spinPrefix: string
  notMiraiz?: boolean | null
  earlyPartnerMail?: boolean | null
  notify: string
  call: string
  timesOfCall: number
  intervalOfCall: number
  timesOfFamilyCall: number
  intervalOfFamilyCall: number
}
export type Sender = {
  sms: string
  call: string
  callEN: string
  familyCall: string
  familyCallEN: string
  serviceStart: string
  serviceStartEN: string
  serviceQuit: string
  serviceQuitEN: string
}
export enum Country {
  JP = 'JP',
  EN = 'EN'
}
export enum ConfirmSpinStatus {
  confirmed = 'confirmed',
  pending = 'pending'
}
export enum GmoPgBankAccountResult {
  SUCCESS = 'SUCCESS',
  PEND = 'PEND',
  FAIL = 'FAIL'
}
export enum MessageStatus {
  call = 'call',
  callDone = 'callDone',
  detectOnStart = 'detectOnStart',
  disasterInfo = 'disasterInfo',
  disasterInfoReport = 'disasterInfoReport',
  disasterInfoNotify = 'disasterInfoNotify',
  disasterInfoPartnerReport = 'disasterInfoPartnerReport',
  denkankyoRequest = 'denkankyoRequest',
  denkankyoResponse = 'denkankyoResponse',
  down = 'down',
  editGmopg = 'editGmopg',
  familyCall = 'familyCall',
  familyCallDone = 'familyCallDone',
  forget = 'forget',
  gmoPg = 'gmoPg',
  inactive = 'inactive',
  monthlyReport = 'monthlyReport',
  monitorEnd = 'monitorEnd',
  monitorStart = 'monitorStart',
  noDetectMonthly = 'noDetectMonthly',
  noDetectOnStart = 'noDetectOnStart',
  noDetectWeekly = 'noDetectWeekly',
  noSpinUsers = 'noSpinUsers',
  noElectricityUsage = 'noElectricityUsage',
  other = 'other',
  partner = 'partner',
  possibleWrongSpin = 'possibleWrongSpin',
  postReport = 'postReport',
  postReportByUsage = 'postReportByUsage',
  register = 'register',
  serviceStart = 'serviceStart',
  serviceQuit = 'serviceQuit',
  serviceStop = 'serviceStop',
  spinCheck = 'spinCheck',
  updateInvoices = 'updateInvoices'
}
export type PartnerUser = {
  name: string
  nameKana?: string | null
  spin: string
  sms: string
  phone: string
  customerNumber: string
  contractNumber: string
  email?: string | null
  postalCode?: string | null
  families?: UserFamily[] | null
  partner: string
  product: string
  criterionsAll?: boolean | null
  criterionsOwn?: boolean | null
  criterions: Criterion[]
  start?: string | null
  end?: string | null
  stop?: string | null
  type: string
  deleted?: boolean | null
  transactionId?: string | null
  place?: string | null
  placeNumber?: string | null
  confirmSpin?: ConfirmSpinStatus | null
  address?: string | null
  addressState?: string | null
  addressStateLater?: string | null
  gmoPgBankAccount?: GmoPgBankAccountResult | null
  gmoCardSeq?: string | null
  country?: Country | null
  attributes?: UserAttribute[] | null
  entry?: string | null
  notMiraiz?: boolean | null
  schedules?: string[] | null
  denkankyoUser?: string | null
  denkankyoUserOlds?: string[] | null
  noDetectMessageStatus?: MessageStatus | null
  test?: boolean | null
  checkSchedules?: CheckSchedules | null
  useOwnCheckSchedules?: boolean | null
  notUseDisasterInfo?: boolean | null
  analytics?: Analytics | null
  id: string
}
export type UserFamily = {
  name: string
  nameKana?: string | null
  phone: string
  postalCode?: string | null
  country?: Country | null
  disabled?: boolean | null
}
export type UserAttribute = {
  key: string
  value: string
}
export type PartnerContractor = {
  name: string
  nameKana: string
  postalCode: string
  address: string
  addressState?: string | null
  addressStateLater?: string | null
  phone: string
  corporation: boolean
  denkankyoUser?: string[] | null
  id: string
}
export enum NotificationKind {
  wakeUp = 'wakeUp',
  goToBed = 'goToBed',
  inactive = 'inactive',
  low = 'low'
}
export type PartnerReport = {
  user: string
  spin: string
  partner: string
  dateTime: string
  dateTimeReal: string
  kind: NotificationKind
  duration: number
  continuous?: number | null
  dateInSchedules?: boolean | null
  type: string
  id: string
}
export enum Status {
  waiting = 'waiting',
  done = 'done',
  confirmed = 'confirmed',
  fail = 'fail',
  unable = 'unable'
}
export enum CallStatus {
  yet = 'yet',
  noAnswer = 'noAnswer',
  confirmed = 'confirmed',
  other = 'other',
  completed = 'completed',
  busy = 'busy',
  failed = 'failed'
}
export type PartnerNotification = {
  user: string
  spin: string
  partner: string
  dateTime: string
  dateTimeReal: string
  kind: NotificationKind
  smsStatus?: Status | null
  smsDate?: string | null
  emailStatus?: Status | null
  callStatus?: Status | null
  familyCallStatus?: Status | null
  partnerCallStatus?: Status | null
  call?: Report | null
  familyCall?: Report | null
  partnerCall?: Report | null
  partnerReport?: Report | null
  confirmed?: boolean | null
  confirmedTime?: string | null
  type: string
  id: string
}
export type Report = {
  status?: CallStatus | null
  report?: string | null
  date?: string | null
  person?: string | null
  digits?: string | null
}
export enum Activity {
  active = 'active',
  inactive = 'inactive'
}
export enum SleepingStatus {
  wakeUp = 'wakeUp',
  goToBed = 'goToBed'
}
export type PartnerDailyElectricityUsage = {
  spin: string
  date: string
  activity?: Activity | null
  frames: Frame[]
  id: string
}
export type Frame = {
  time: string
  amount?: number | null
  activity?: Activity | null
  sleepingStatus?: SleepingStatus | null
  activityReal?: Activity | null
  criterionTime?: boolean | null
}
export type PartnerInvoice = {
  partner: string
  product: string
  date: string
  items: InvoiceItem[]
  prices: Price[]
  orders?: OrderItem[] | null
  count: number
  sum: number
  type: string
  gmoPg?: boolean | null
  id: string
}
export type InvoiceItem = {
  count: number
  price: number
  amount: number
}
export type OrderItem = {
  count: number
  price: number
  amount: number
  chargeDate: string
}
export type PartnerPreference = {
  setR: SetR
  setA: SetA
  setS: SetS
  setCommon: SetCommon
  id: string
}
export type SetR = {
  emailSender: string
  emailNotificationSender: string
  email: string
  sms: string
  templates: Templates
  postReportResponse: string
  postReportResponseEN: string
  callFrom: string
  voiceTemplates: VoiceTemplates
  checkSchedules?: CheckSchedules[] | null
}
export type Templates = {
  inactive: Template
  call: Template
  callDone: Template
  familyCall: Template
  familyCallDone: Template
  noElectricityUsage: Template
  postReport: Template
  postReportByUsage: Template
  possibleWrongSpin: Template
  partner: Template
  partnerReport: Template
  serviceStart: Template
  serviceQuit: Template
  serviceStop: Template
  disasterInfo: Template
  disasterInfoReport: Template
  disasterInfoNotify: Template
  disasterInfoPartnerReport: Template
  spinCheck: Template
  denkankyoRequest: Template
  denkankyoResponse: Template
  noSpinUsers: Template
}
export type Template = {
  sms?: string | null
  subject?: string | null
  body?: string | null
  notifySubject?: string | null
  notifyBody?: string | null
  smsEN?: string | null
}
export type VoiceTemplates = {
  call: VoiceTemplate
  familyCall: VoiceTemplate
  serviceStart: VoiceTemplate
  serviceQuit: VoiceTemplate
}
export type VoiceTemplate = {
  sender?: string | null
  call?: string | null
  ask?: string | null
  gather?: string | null
  hangup?: string | null
  hangupContinue?: string | null
  senderEN?: string | null
  callEN?: string | null
  askEN?: string | null
  gatherEN?: string | null
  hangupEN?: string | null
  hangupContinueEN?: string | null
}
export type SetA = {
  emailSender: string
  emailNotificationSender: string
  email: string
  sms: string
  partner: string
  product: string
  templates: TemplatesA
}
export type TemplatesA = {
  register: Template
  detectOnStart: Template
  down: Template
  editGmopg: Template
  forget: Template
  monitorEnd: Template
  monitorStart: Template
  noDetectMonthly: Template
  noDetectOnStart: Template
  noDetectWeekly: Template
  serviceStart: Template
  serviceQuit: Template
}
export type SetS = {
  emailSender: string
  emailNotificationSender: string
  email: string
  templates: TemplatesS
}
export type TemplatesS = {
  solarReport: Template
}
export type SetCommon = {
  emailNotificationSender: string
  email: string
  templates: TemplatesCommon
}
export type TemplatesCommon = {
  gmoPg: Template
  updateInvoices: Template
}
export enum MessageResult {
  done = 'done',
  fail = 'fail',
  sending = 'sending',
  unable = 'unable'
}
export type PartnerEmail = {
  toId: string
  partner: string
  to: string
  subject: string
  cc?: string | null
  bcc?: string | null
  body: string
  status: MessageStatus
  dateTime: string
  success: MessageResult
  filenames?: string[] | null
  type: string
  id: string
}
export type PartnerShortMessage = {
  toId: string
  partner: string
  to: string
  body: string
  status: MessageStatus
  dateTime: string
  success: MessageResult
  transactionId?: string | null
  notification?: string | null
  type: string
  id: string
}
export enum Command {
  createElectricityUsageData = 'createElectricityUsageData',
  notificationReportCheck = 'notificationReportCheck'
}
export type PartnerTest = {
  user: string
  command?: Command | null
  date?: string | null
  endDate?: string | null
  start?: string | null
  duration?: number | null
  activity?: Activity | null
  dateTime: string
  type: string
  id: string
}
export type PartnerTransaction = {
  count: number
  done: number
  smsCompletes?: string[] | null
  smsFails?: string[] | null
  smsUnables?: string[] | null
  id: string
}
export type PartnerCall = {
  to: string
  toId?: string | null
  name: string
  status: CallStatus
  kind: MessageStatus
  notification?: string | null
  dateTime: string
  type: string
  id: string
}
export type PartnerRedial = {
  to: string
  toId?: string | null
  name: string
  status: MessageStatus
  notification?: string | null
  dateTime: string
  retry: number
  type: string
  id: string
}
export type PartnerGmoPg = {
  partner: string
  user?: string | null
  useBankAccount?: boolean | null
  targetDate?: string | null
  useCreditCard?: boolean | null
  product: string
  date: string
  dateTime: string
  amount: number
  tax: number
  success?: boolean | null
  invoiceId: string
  redo?: boolean | null
  gmoError?: string | null
  gmoOrderId?: string | null
  gmoApprove?: string | null
  gmoTransactionId?: string | null
  gmoTransactionDate?: string | null
  gmoRequestAcceptEndDate?: string | null
  gmoTransferReturnDate?: string | null
  gmoBankAccountStatus?: string | null
  gmoBankAccountProcessDate?: string | null
  gmoBankAccountWithdrawalDate?: string | null
  gmoBankAccountResultCode?: string | null
  type: string
  id: string
}
export type PartnerDisasterInfo = {
  dataconf: DataConf
  prodIdInfo: ProdIdInfo
  body: Body
  date: string
  dateTime: string
  attribute?: Attribute | null
  name: string
  type: string
  id: string
}
export type DataConf = {
  conf: string
}
export type ProdIdInfo = {
  infoId: string
  category0: string
  name0: string
  category1: string
  name1: string
  category2?: string | null
  name2?: string | null
  publishTime: string
  followupNum: string
  limitTime: string
  levelInfo?: number | null
  areaKbn: string
  levelEarea?: string | null
  upDelFg: string
}
export type Body = {
  title: string
  text1: string
  text2: string
  area?: Area[] | null
}
export type Area = {
  levelInfo: number
  p0: AreaP
  p1: AreaP
  p2?: AreaP | null
  p3?: AreaP | null
  p4?: AreaP | null
  p5?: AreaP | null
  note?: string | null
}
export type AreaP = {
  code: string
  name: string
}
export type Attribute = {
  common?: string | null
  weth_warn?: WethWarn | null
  detail?: Detail | null
  detailOfQuake?: DetailOfQuake | null
  detailOfTsunami?: DetailOfTsunami | null
  detailOfRiver?: DetailOfRiver | null
  areaText?: string | null
}
export type WethWarn = {
  warnInfo?: WarnInfo[] | null
}
export type WarnInfo = {
  warncode: string
  warnname: string
  annckbn: string
  condition?: string | null
  conditionId?: string | null
  nextKinds?: NextKind[] | null
}
export type NextKind = {
  nextKind?: NextKindItem | null
}
export type NextKindItem = {
  warncode: string
  warnname: string
  condition?: string | null
  conditionId?: string | null
  nextKindTime: string
  precision: string
  nextKindText: string
}
export type Detail = {
  city?: City[] | null
  volcKind?: string | null
  volcLevel?: string | null
  volcStatus?: string | null
  volcSup?: string | null
  areaText?: string | null
  area?: AreaOfAreaOrRegion[] | null
  region?: string | null
}
export type City = {
  code: string
  name: string
  levelInfo?: number | null
  warnInfo?: WarnInfoOfCity[] | null
  title?: string | null
  text?: string | null
  text1?: string | null
  text2?: string | null
  area?: AreaOfRegion | null
}
export type WarnInfoOfCity = {
  warncode: string
  warnname: string
  annckbn: string
  condition?: string | null
  conditionId?: string | null
  nextKinds?: NextKind[] | null
}
export type AreaOfRegion = {
  area?: AreaOfAreaOrRegion[] | null
}
export type AreaOfAreaOrRegion = {
  code: string
  name: string
  riverWarn?: string | null
  levelInfo?: number | null
  tsunami?: string | null
  ArrivalTime?: string | null
  height?: string | null
  status?: string | null
  title: string
  text: string
}
export type DetailOfQuake = {
  city?: AreaOfRegion | null
  quakeInfo: QuakeInfo
  region?: AreaOfRegion | null
}
export type QuakeInfo = {
  epicenter: string
  latitude?: number | null
  longitude?: number | null
  depth?: number | null
  magnitude?: number | null
  detailText: string
  areaText: string
}
export type DetailOfTsunami = {
  areaText?: string | null
  region?: AreaOfRegion | null
}
export type DetailOfRiver = {
  area?: AreaOfRiver | null
  expectedInundationArea: ExpectedInundationArea
}
export type AreaOfRiver = {
  code: string
  name: string
  riverWarn: string
}
export type ExpectedInundationArea = {
  expectedInundationAreaName?: string | null
  expectedInundationAreaCode?: string | null
  expectedInundationCity?: ExpectedInundationCity[] | null
}
export type ExpectedInundationCity = {
  expectedInundationCityCode?: string | null
  expectedInundationCityName?: ExpectedInundationCityName | null
}
export type ExpectedInundationCityName = {
  waterLevelStations?: WaterLevelStation[] | null
}
export type WaterLevelStation = {
  waterLevelStationName?: string | null
  cityArea?: string | null
}
export enum SafetyKind {
  Answer = 'Answer',
  Report = 'Report',
  Notify = 'Notify'
}
export type PartnerSafety = {
  user: string
  partner: string
  product: string
  disasterInfo: string
  disasterInfoText: string
  kind: SafetyKind
  status?: string | null
  houseStatus?: string | null
  message?: string | null
  to: string
  from?: string | null
  dateTime: string
  answerDateTime?: string | null
  type: string
  id: string
}
export type PartnerDenkankyoUser = {
  consentApplicationStatus: string
  contractorDivision: string
  contractorInfo: ContractorInfo
  contractorIdentifyKey?: string | null
  consumerSpcfcId?: string | null
  pointInfo: PointInfo[]
  serviceUserInfo: ServiceUserInfo
  consentForm: string
  operatorAgencyInformation: OperatorAgencyInformation
  consentApplicationNo?: string | null
  consentApplicationResultReflectionDate?: string | null
  start: string
  complete?: string | null
  user: string
  requestResult?: DenkankyoRequestResponse | null
  response?: DenkankyoResponse | null
  cancelRequestResult?: DenkankyoCancelRequestResponse | null
  cancelResponse?: DenkankyoResponse | null
  type: string
  id: string
}
export type ContractorInfo = {
  contractorNameKanji: string
  contractorNameKana: string
  contractorAddressPostalCode: string
  contractorAddressState: string
  contractorAddressStateLater: string
  contractorPhoneNumber: string
}
export type PointInfo = {
  pointPostalCode: string
  pointAddressState: string
  pointAddressStateLater: string
  spplyRcvngPwrPntSpcfcNo?: string | null
  pointMeterId?: string | null
  pointVoltageClassification: string
  pointContractFacilityType: string
  pointSpplyRcvngPwrDivision: string
}
export type ServiceUserInfo = {
  serviceUserId: string
  serviceUserName: string
  serviceUserNameKana: string
  serviceDepartmentPosition?: string | null
  servicePhoneNumber: string
  serviceEmail?: string | null
}
export type OperatorAgencyInformation = {
  operatorAgencyMemberServiceId: string
  operatorConsentFormConfirmNoFlg: string
  operatorName?: string | null
}
export type DenkankyoRequestResponse = {
  status: string
  result: RequestResult
}
export type RequestResult = {
  errorMessage?: string | null
  consentApplicationNo?: string | null
}
export type DenkankyoResponse = {
  status: string
  result?: ResponseResult | null
  consentApplicationInfo?: ConsentApplicationInfo[] | null
}
export type ResponseResult = {
  errorMessage?: string | null
}
export type ConsentApplicationInfo = {
  consentApplicationNo: string
  consentApplicationStatus: string
  contractorInfo: ReponseContractorInfo
  pointInfo: PointInfoInResponse[]
  serviceUserId: string
}
export type ReponseContractorInfo = {
  contractorDivision: string
  contractorName: string
  contractorAddressState: string
  identificationResultInfo: IdentificationResult
  initialUserId?: string | null
  initialPassword?: string | null
}
export type IdentificationResult = {
  identificationResult: string
  identificationIncompleteContent?: string | null
}
export type PointInfoInResponse = {
  pointAddressState: string
  pointMeterId?: string | null
  pointVoltageClassification?: string | null
  pointContractFacilityType?: string | null
  pointSpplyRcvngPwrDivision?: string | null
  pointConfirmationResultInfo: PointConfirmationResultInfo
  contractMatchingResultInfo: ContractMatchingResultInfo
}
export type PointConfirmationResultInfo = {
  pointConfirmationResult: string
  pointConfirmationIncompleteContent?: string | null
}
export type ContractMatchingResultInfo = {
  contractMatchingResult: string
  contractMatchingIncompleteContent?: string | null
  consentInfoId?: string | null
  consumerSpcfcId?: string | null
  spplyRcvngPwrPntSpcfcNo?: string | null
}
export type DenkankyoCancelRequestResponse = {
  status: string
  result: CancelResult
}
export type CancelResult = {
  errorMessage?: string | null
  consentChangeInfo?: ConsentChangeInfo[] | null
}
export type ConsentChangeInfo = {
  consentInfoId: string
  processResult: string
  consentApplicationNo?: string | null
  consentStatus?: string | null
}
